import {SET_SPARES_CAR_BRANDS_LIST} from "../../Actions/ActionConstants";

const CarBrandsListReducer = (state = null, action) => {
    if (action.type === SET_SPARES_CAR_BRANDS_LIST) {
        return action.data;
    } else {
        return state;
    }
};
export default CarBrandsListReducer
